<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area tech03">
      <div class="tit_area">
        <div class="sub_tit">시행사업</div>
        <div class="sub_txt">
          고객의 라이프 스타일에 맞는 문화를 만들어 갑니다.
        </div>
        <!--// 21-08-17 내용 수정-->
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <div class="tech_slide">
        <div class="techSlide11 tech_slide01" ref="techSwiperRef">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img
                :src="`${resources}img/tech_slide05_01.png`"
                class="swiper-lazy"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>
            <div class="swiper-slide">
              <img
                :src="`${resources}img/tech_slide05_02.png`"
                class="swiper-lazy"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>
            <div class="swiper-slide">
              <img
                :src="`${resources}img/tech_slide05_03.png`"
                class="swiper-lazy"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>
            <div class="swiper-slide">
              <img
                :src="`${resources}img/tech_slide05_04.png`"
                class="swiper-lazy"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>
            <div class="swiper-slide">
              <img
                :src="`${resources}img/tech_slide05_05.png`"
                class="swiper-lazy"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>
            <div class="swiper-slide">
              <img
                :src="`${resources}img/tech_slide05_06.png`"
                class="swiper-lazy"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>
          </div>
        </div>
        <div class="tech-navi">
          <div class="tech-button-prev"></div>
          <div class="tech-button-next"></div>
        </div>
        <div class="techSlide12 tech_slide02" ref="techSwiperRef2">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img
                :src="`${resources}img/tech_slide05_s01.png`"
                class="swiper-lazy"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>
            <div class="swiper-slide">
              <img
                :src="`${resources}img/tech_slide05_s02.png`"
                class="swiper-lazy"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>
            <div class="swiper-slide">
              <img
                :src="`${resources}img/tech_slide05_s03.png`"
                class="swiper-lazy"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>
            <div class="swiper-slide">
              <img
                :src="`${resources}img/tech_slide05_s04.png`"
                class="swiper-lazy"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>
            <div class="swiper-slide">
              <img
                :src="`${resources}img/tech_slide05_s05.png`"
                class="swiper-lazy"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>
            <div class="swiper-slide">
              <img
                :src="`${resources}img/tech_slide05_s06.png`"
                class="swiper-lazy"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="mgt100">
        <img
          :src="`${resources}img/img_tech_04-1.jpg`"
          alt="STEP 01사업지 파악 및 사업성 검토(- 시행사업 입지 분석 - 사업타당성 검토), STEP 02자금 조달 및 토지 계약(- 금융기관 시공사 PF 협의 - 토지 계약 및 계약금 진행), STEP 03시공사 선정 및 인허가 진행 (- 시공 및 금융담보 제공할 건설사 선정 - 건축심의 사업승인(건축허가)신청),STEP 04PF 프로젝트파이낸싱(PF) 대출 및 토지 비용 납부(- PF대출 준비 및 대출 진행 - 확보 자금으로 토지 비용 납부),STEP 05착공 및 분양 (- 건축물 공사 시작 - 분양관련 업무 수행 및 분양 실행),STEP 06공사관리 및 준공 후 사후관리 (- 사용승인까지 공사관리 - 준공 및 입주 후 관리)"
        />
      </div>
      <div class="tbl_ty01 bod align_td_cnt mgt80">
        <table>
          <caption>
            건축사업
          </caption>
          <colgroup>
            <col style="width: 25%" />
            <col style="width: 35%" />
            <col style="width: 20%" />
            <col style="width: 20%" />
          </colgroup>
          <thead>
            <th scope="row">시공사</th>
            <th scope="row">현장명</th>
            <th scope="row">연 도</th>
            <th scope="row">시행실적 (단위:억원)</th>
          </thead>
          <tbody>
            <tr>
              <td>GS건설</td>
              <td>고양덕은 DMC한강자이더헤리티지</td>
              <td>2020</td>
              <td>4,282</td>
            </tr>
            <tr>
              <td>대우건설㈜</td>
              <td>판교 푸르지오그랑블 아파트</td>
              <td>2008</td>
              <td>3,400</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import Swiper from 'swiper';
import page from '@/mixins/page';

export default {
  mixins: [page],
  mounted() {
    // 시행사업
    const mySwiper1 = new Swiper(this.$refs.techSwiperRef, {
      loop         : true,
      slidesPerView: 'auto',
      spaceBetween : 10,
      navigation   : {
        nextEl: '.tech-button-next',
        prevEl: '.tech-button-prev'
      },
      lazy: {
        loadPrevNext: true
      }
    });
    const mySwiper2 = new Swiper(this.$refs.techSwiperRef2, {
      slidesPerView: 'auto',
      spaceBetween : 20,
      freemode     : false,
      loop         : true,
      lazy         : {
        loadPrevNext      : true,
        loadPrevNextAmount: 4
      }
    });
    mySwiper1.controller.control = mySwiper2;
    mySwiper2.controller.control = mySwiper1;
  }
};
</script>

<style lang="scss" scoped>
.techSlide11 {
  .swiper-wrapper .swiper-slide {
    min-height: 500px;
    background-color: #f1f1f1;
  }
}
.techSlide12 {
  .swiper-wrapper .swiper-slide {
    min-height: 160px;
    background-color: #f1f1f1;
  }
}
</style>
